export const DigitalDraftsActionTypes = {
  DIGITAL_REQUEST_DRAFTS: 'zola/card/card_project/DIGITAL_REQUEST_DRAFTS',
  DIGITAL_RECEIVE_DRAFTS: 'zola/card/card_project/DIGITAL_RECEIVE_DRAFTS',
  DIGITAL_RECEIVE_DELETE_DRAFT: 'zola/cards/card_project/DIGITAL_RECEIVE_DELETE_DRAFT',
  DIGITAL_ADD_REMOVED_ORDER: 'zola/cards/card_project/DIGITAL_ADD_REMOVED_ORDER',
};

export default DigitalDraftsActionTypes;
